var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import clsx from 'clsx';
import { Checkbox } from '@homeexchange/design';
import i18n from '../../../../i18n';
import styles from './collectionLuxury.module.scss';
export var CollectionLuxuryFilter = function (_a) {
    var checked = _a.checked, onChange = _a.onChange, isEligibleCollection = _a.isEligibleCollection;
    var handleInputChange = function (event) {
        onChange(event.target.value, event.target.checked);
    };
    return (React.createElement("div", { className: styles['container'] },
        React.createElement(Checkbox, __assign({ label: i18n.t('search:filter.luxury'), message: i18n.t('collection:collection-filter.text'), value: "luxury", checked: checked, onChange: handleInputChange }, (isEligibleCollection && { disabled: true }))),
        isEligibleCollection && (React.createElement("div", { className: styles['eligible'] },
            React.createElement("div", { className: styles['eligible-title'] },
                React.createElement("span", { className: clsx('icon', 'icon-pwd-lock', styles['icon-container']) }),
                ' ',
                React.createElement("span", null, i18n.t('search:collection.luxury-homes-filter.eligible-block.title'))),
            React.createElement("div", { className: styles['eligible-text'] }, i18n.t('search:collection.luxury-homes-filter.eligible-block.text')),
            React.createElement("div", { className: styles['eligible-learn-more'] },
                React.createElement("a", { href: i18n.t('url:my-plan.url') }, i18n.t('common:learn_more')))))));
};
